export default Object.freeze({
  TOKBOX: 'tokbox',
  LIVESTREAM: 'livestream'
})
